// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"StoryView_wrapper__1brsF","image":"StoryView_image__3CVe2","name":"StoryView_name__29Rzy","firstName":"StoryView_firstName__1PL7t","lastName":"StoryView_lastName__dzOWc"};